import React from 'react'
export const SectionalAlertErrorIcon = () => {
  return (
    <svg id="Alert_Icon_-_Error" data-name="Alert Icon - Error" className='flex-shrink-0 overflow-visible' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <title>Error Icon</title>
      <path id="exclamation-circle" d="M26,17a9,9,0,1,1-9-9A9,9,0,0,1,26,17Zm-9,1.815a1.669,1.669,0,1,0,1.669,1.669A1.669,1.669,0,0,0,17,18.815Zm-1.585-6,.269,4.935a.435.435,0,0,0,.435.412h1.762a.435.435,0,0,0,.435-.412l.269-4.935a.435.435,0,0,0-.435-.459h-2.3A.435.435,0,0,0,15.415,12.814Z" transform="translate(-8 -8)" fill="#c33" />
    </svg>

  )
}